import 'react-step-progress-bar/styles.css';
import { ProgressBar, Step } from 'react-step-progress-bar';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectGiftProgress, selectIsStarted, selectViewPrefilledForm } from '../../giftSlice';
import { launch, takeoff, fly } from '../../assets/index';

const GiftProgressBar = () => {
  const progress = useSelector(selectGiftProgress);
  const myForm = useSelector(selectViewPrefilledForm);
  const isStarted = useSelector(selectIsStarted);
  return (
    !myForm &&
    isStarted && (
      <Box sx={{ p: 1, mt: 1 }}>
        <ProgressBar percent={progress} filledBackground='linear-gradient(to right, #fefb72, #f0bb31)'>
          <Step transition='scale'>
            {({ accomplished }) => (
              <img
                style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                width='30'
                src={launch}
                //   src='https://vignette.wikia.nocookie.net/pkmnshuffle/images/9/9d/Pichu.png/revision/latest?cb=20170407222851'
              />
            )}
          </Step>
          <Step transition='scale'>
            {({ accomplished }) => (
              <img
                style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                width='40'
                src={takeoff}
                //   src='https://vignette.wikia.nocookie.net/pkmnshuffle/images/9/97/Pikachu_%28Smiling%29.png/revision/latest?cb=20170410234508'
              />
            )}
          </Step>
          <Step transition='scale'>
            {({ accomplished }) => (
              <img
                style={{ filter: `grayscale(${accomplished ? 0 : 80}%)` }}
                width='30'
                src={fly}
                //   src='https://orig00.deviantart.net/493a/f/2017/095/5/4/raichu_icon_by_pokemonshuffle_icons-db4ryym.png'
              />
            )}
          </Step>
        </ProgressBar>
      </Box>
    )
  );
};

export default GiftProgressBar;
